import styled, { css } from 'styled-components';

import { getThemeColor } from '~/common/utils/get-theme-color';
import { SPACING } from '~/common/layout-propertis/spacing';
import { Z_INDEX } from '~/common/constants/z-index';
import { AboveComponentBoxPositionTypes } from '~/common/@types/AboveComponentBoxPositionTypes';
import { AboveComponentArrowPositionTypes } from '~/common/@types/AboveComponentArrowPositionTypes';

export const BoxWrapper = styled.div<{
  $visible: boolean;
  $position: AboveComponentBoxPositionTypes;
  $withoutPadding: boolean;
  $popover: boolean;
  backgroundColor?: 'neutral.50' | 'neutral.950';
}>`
  position: absolute;
  z-index: ${Z_INDEX.POPOVER};
  left: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: ${SPACING._12};
  box-shadow: 0px 1px 2px rgba(14, 18, 27, 0.03);
  background-color: ${({ theme, backgroundColor }) =>
    getThemeColor(theme, backgroundColor)};
  color: white;
  padding: ${({ $withoutPadding }) => ($withoutPadding ? 0 : '8px')};
  border-radius: 4px;
  font-size: 14px;
  white-space: nowrap;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  visibility: ${({ $visible }) => ($visible ? 'visible' : 'hidden')};
  transition: 200ms;
  pointer-events: ${({ $popover }) => ($popover ? 'all' : 'none')};

  ${({ $position }) =>
    $position === 'top' &&
    css`
      bottom: 100%;
      transform: translateX(-50%);
    `}

  ${({ $position }) =>
    $position === 'bottom' &&
    css`
      top: 100%;
      transform: translateX(-50%);
    `}

  
  ${({ $position }) =>
    $position === 'left' &&
    css`
      right: 100%;
      bottom: 0;
    `}

    
  ${({ $position }) =>
    $position === 'right' &&
    css`
      left: calc(100% + 10px);
      bottom: 0;
    `}

    // @todo estilizar a arrow em caso da borda presente (cor escura)
  ${({ theme, backgroundColor }) =>
    backgroundColor === 'neutral.950' &&
    css`
      outline: 1px ${theme.neutral[800]} solid;
    `}
`;

export const Arrow = styled.div<{
  $visible: boolean;
  $position: string;
  background: 'neutral.50' | 'neutral.950';
  $side: AboveComponentArrowPositionTypes;
}>`
  position: absolute;
  width: 8px;
  height: 8px;
  z-index: ${Z_INDEX.POPOVER + 1};
  transition: 200ms;
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: rotate(45deg);
  background-color: ${({ theme, background }) =>
    getThemeColor(theme, background)};

  ${({ $position, $side }) => {
    switch ($position) {
      case 'top':
        return css`
          top: -4px;
          left: ${$side === 'center'
            ? '50%'
            : $side === 'left'
            ? '15%'
            : '85%'};
        `;
      case 'bottom':
        return css`
          bottom: -4px;
          left: ${$side === 'center'
            ? '50%'
            : $side === 'left'
            ? '15%'
            : '85%'};
        `;
      case 'right':
        return css`
          left: -4px;
          bottom: 8px;
        `;

      case 'left':
        return css`
          right: -4px;
          bottom: 8px;
        `;

      default:
        return '';
    }
  }}
`;
